import { useEffect, useState } from 'react';

type Params = {
  // Any URL on the API origin, e.g. `https://api.example.com/`
  apiBaseUrl?: string;
  expectedVersion: string;
};

// Fails open: any error or non-2xx leaves this false so nothing is shown. Unexpected payload is treated as mismatch.
export const useIsAuthVersionMismatched = ({ apiBaseUrl, expectedVersion }: Params) => {
  const [isMismatched, setIsMismatched] = useState(false);

  useEffect(() => {
    if (!apiBaseUrl) return;

    const controller = new AbortController();

    const checkVersion = async () => {
      try {
        const versionUrl = new URL('/v3/auth/version', apiBaseUrl);
        const response = await fetch(versionUrl, { signal: controller.signal });
        if (!response.ok) {
          throw `Server responded with ${response.statusText}`;
        }

        const body = await response.json();
        if (typeof body?.version !== 'string' || !body.version) {
          console.warn(`Auth version check encountered an unexpected format; assuming a version mismatch.`);
          setIsMismatched(true);

          return;
        }

        setIsMismatched(body.version !== expectedVersion);
      } catch (error) {
        // Fail open, with just a warning in the console.
        console.warn('Unable to check auth version:', error);
      }
    };

    checkVersion();

    return () => controller.abort();
  }, [apiBaseUrl, expectedVersion]);

  return isMismatched;
};
